import { callApi } from "@app/api";

export const codeLogin = (code, email) => callApi("student_code/login/", {
  method: "POST",
  type: "JSON",
  body: { code, email },
});


export const loginValue = (code, fullName) => callApi("class_code/login/", {
  method: "POST",
  type: "JSON",
  body: { code, full_name: fullName },
});

export const verifyVersion = () => callApi("version/", {
  method: "GET",
});

export const login = (username, password) => callApi("jwt_create/", {
  method: "POST",
  type: "JSON",
  body: { username, password },
});

export const socialLogin = async (provider) => {
  const { response } = await callApi(`auth/o/${provider}-oauth2/`, {
    method: "GET",
    params: {
      redirect_uri: `${window.location.origin}/login/${provider}/success/`,
    },
    type: "URL_ENCODED",
  });
  window.location.assign(response.authorization_url);
};

export const generateStudentChallenge = () => callApi("student_otp/generate_challenge/", {
  method: "POST",
});

export const generateChallenge = () => callApi("totp/generate_challenge/", {
  method: "POST",
});

export const providerLogin = async (provider, state, code) => {
  const params = {
    state,
    code,
  };
  const formBody = Object.keys(params).map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`).join("&");
  return callApi(`auth/o/${provider}-oauth2/?${formBody}`, {
    method: "POST",
    params: {
      redirect_uri: `${window.location.origin}/login/${provider}/success/`,
    },
    type: "URL_ENCODED",
  });
};

export const createOTP = () => callApi("totp/create/", {
  method: "GET",
});

export const loginStudentOTP = (code) => callApi("student_otp/verifyOTP/", {
  method: "POST",
  body: { code },
});

export const loginOTP = (code) => callApi(`totp/login/${code}/`, {
  method: "POST",
});

export const loadCurrentUser = () => {
  let path = "auth/users/me/";
  if (localStorage.getItem("class_login_token")) {
    path = "class_code/me/";
  } else if (localStorage.getItem("code_login_token")) {
    path = "student_code/me/";
  }
  return callApi(path, { method: "GET" });
};

export const logout = () => callApi("logout/all/", {
  method: "POST",
});

export const password = (username) => callApi("auth/password/reset/", {
  method: "POST",
  body: {
    username,
  },
});

export const passwordReset = (new_pwd, re_new_pwd, uuid, token) => callApi("auth/password/reset/confirm/", {
  method: "POST",
  body: {
    new_password: new_pwd,
    re_new_password: re_new_pwd,
    uid: uuid,
    token,
  },
});

export const checkResetTokenValid = (uid, token) => callApi("users/check_reset_token/", {
  method: "POST", body: { uid, token },
});

export const passwordChange = (old_pwd, new_pwd, re_new_pwd) => callApi("users/change_password/", {
  method: "POST",
  body: {
    old_password: old_pwd,
    new_password: new_pwd,
    re_new_password: re_new_pwd,
  },
});

export const passwordNotificationTSChange = (ts) => callApi("users/update_notification_ts/", {
  method: "POST",
  body: {
    password_notified_at: ts,
  },
});
